// ternary operators due to errors in JEST
export const version = window.buildTimestamp;

export const isNoWebsockets = `${window.isNoWebsockets}` === 'true';

export const NODE_ENV = window.BUILD ? window.BUILD.getNodeENV() : 'prod';

// VITE_IS_LOCAL is set in vite.config.js
// eslint-disable-next-line no-undef
export const isLocal = () => VITE_IS_LOCAL === 'true';

export const Env = window.BUILD
  ? window.BUILD.getENVConfig()
  : {
      AuthUrlPrefix: '',
      RestUrlPrefix: '',
      WSUrlPrefix: '',
      ChemaxonUrlPrefix: '',
      AvailabilityUrlPrefix: '',
      AutosuggestUrlPrefix: '',
      StaticHostUrl: '',
      StructureEditorsHostUrl: '',
    };

export const { PENDO_URL } = window;
export const { PENDO_FEEDBACK_URL } = window;
